// src/index.ts
import { ParachainId } from "@zenlink-interface/chain";

// src/config/rpc.json
var rpc_default = {
  farming: {
    getFarmingRewards: {
      description: "Get farming rewards",
      params: [
        {
          name: "who",
          type: "AccountId"
        },
        {
          name: "pid",
          type: "PoolId"
        },
        {
          name: "at",
          type: "Hash",
          isOptional: true
        }
      ],
      type: "Vec<(CurrencyId, Balance)>",
      isSubscription: false,
      jsonrpc: "farming_getFarmingRewards",
      method: "getFarmingRewards",
      section: "farming"
    },
    getGaugeRewards: {
      description: "Get gauge rewards",
      params: [
        {
          name: "who",
          type: "AccountId"
        },
        {
          name: "pid",
          type: "PoolId"
        },
        {
          name: "at",
          type: "Hash",
          isOptional: true
        }
      ],
      type: "Vec<(CurrencyId, Balance)>",
      isSubscription: false,
      jsonrpc: "farming_getGaugeRewards",
      method: "getGaugeRewards",
      section: "farming"
    }
  }
};

// src/config/types.json
var types_default = {
  PoolId: "u32",
  CurrencyId: "u32"
};

// src/index.ts
var parachains = [
  // {
  //   id: ParachainId.BIFROST_KUSAMA,
  //   name: 'Bifrost Kusama',
  //   network: 'bifrost kusama',
  //   nativeCurrency: { name: 'Bifrost', symbol: 'BNC', decimals: 12 },
  //   endpoints: [
  //     'wss://bifrost-rpc.liebi.com/ws',
  //     'wss://bifrost-parachain.api.onfinality.io/public-ws',
  //   ],
  //   blockExplorers: {
  //     default: {
  //       name: 'subscan',
  //       url: 'https://bifrost-kusama.subscan.io',
  //     },
  //   },
  //   apiOptions: {
  //     rpc: bifrostRpc,
  //     types: bifrostTypes,
  //     typesAlias: bifrostTypeAlias,
  //     typesBundle: bifrostTypesBundle,
  //   },
  // },
  // {
  //   id: ParachainId.BIFROST_POLKADOT,
  //   name: 'Bifrost Polkadot',
  //   network: 'bifrost polkadot',
  //   nativeCurrency: { name: 'Bifrost', symbol: 'BNC', decimals: 12 },
  //   endpoints: [
  //     'wss://hk.p.bifrost-rpc.liebi.com/ws',
  //     'wss://bifrost-polkadot.api.onfinality.io/public-ws',
  //   ],
  //   blockExplorers: {
  //     default: {
  //       name: 'subscan',
  //       url: 'https://bifrost.subscan.io',
  //     },
  //   },
  //   apiOptions: {
  //     rpc: bifrostRpc,
  //     types: bifrostTypes,
  //     typesAlias: bifrostTypeAlias,
  //     typesBundle: bifrostTypesBundle,
  //   },
  // },
  // {
  //   id: ParachainId.CALAMARI_KUSAMA,
  //   name: 'Calamari Network',
  //   network: 'calamari kusama',
  //   nativeCurrency: { name: 'Calamari', symbol: 'KMA', decimals: 12 },
  //   endpoints: [
  //     'wss://zenlink.zqhxuyuan.cloud:444',
  //   ],
  //   blockExplorers: {
  //     default: {
  //       name: 'subscan',
  //       url: 'https://calamari.subscan.io',
  //     },
  //   },
  //   apiOptions: {
  //     rpc,
  //     types,
  //   },
  // },
  // {
  //   id: ParachainId.MANTA_STAGING,
  //   name: 'Manta Staging',
  //   network: 'manta staging',
  //   nativeCurrency: { name: 'Manta', symbol: 'MANTA', decimals: 18 },
  //   endpoints: [
  //     'wss://c1.manta.seabird.systems',
  //   ],
  //   blockExplorers: {
  //     default: {
  //       name: 'subscan',
  //       url: 'https://manta.subscan.io',
  //     },
  //   },
  //   apiOptions: {
  //     rpc,
  //     types,
  //   },
  // },
  {
    id: ParachainId.MANTA_POLKADOT,
    name: "Manta Atlantic",
    network: "manta atlantic",
    nativeCurrency: { name: "Manta", symbol: "MANTA", decimals: 18 },
    endpoints: [
      "wss://ws.archive.manta.systems"
    ],
    blockExplorers: {
      default: {
        name: "subscan",
        url: "https://manta.subscan.io"
      }
    },
    apiOptions: {
      rpc: rpc_default,
      types: types_default
    }
  }
];
export {
  parachains
};
